import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import ApplePayDeleteDomainModal from 'modules/profile/payment-gateways/integrations/stripe/components/apple-pay-delete-domain-modal'
import { ApplePayDomain } from 'modules/profile/payment-gateways/integrations/stripe/hooks'
import ButtonLikeLink from 'shared/components/button-like-link'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export interface ApplePayDomainListProps {
  domains: ApplePayDomain[]
  afterLeave: () => void
}

const ApplePayDomainList = ({ domains, afterLeave }: ApplePayDomainListProps) => {
  const { t } = useLocoTranslation()

  return (
    <Disclosure>
      {({ open }) => (
        <>
          <DisclosureButton as={ButtonLikeLink}>
            {open
              ? t('dashboard.settings.apple_pay.hide_connected_domains')
              : t('dashboard.settings.apple_pay.show_connected_domains')}
          </DisclosureButton>
          <DisclosurePanel>
            {domains.map(({ id, host_name }) => (
              <ApplePayDeleteDomainModal
                key={id}
                hostName={host_name}
                domainId={id}
                afterLeave={afterLeave}
              />
            ))}
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  )
}

export default ApplePayDomainList
